import React from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import { TextField, Typography, useTheme } from "@mui/material";
import { withTranslation } from "react-i18next";
import styled from "@emotion/styled";

const StyledTextField = styled(TextField)`
  label {
    width: 100%;
  }
`;

const InputFieldText = ({
  formik,
  name = "",
  errorMessage,
  disabled = false,
  placeholder = "",
  t,
  // eslint-disable-next-line no-unused-vars, react/prop-types
  tReady,
  ...props
}) => {
  const { touched, values, errors, handleBlur, handleChange } = formik || {};
  const isError =
    !disabled && !!get(touched, name, "") && !!get(errors, name, "");

  const theme = useTheme();

  const formikProps = formik
    ? {
        onChange: handleChange,
        onBlur: handleBlur,
        value: get(values, name, ""),
      }
    : {};

  return (
    <div className="mb-1">
      <StyledTextField
        name={name}
        className="w-100"
        size="small"
        error={isError || !!errorMessage}
        disabled={disabled}
        autoComplete="off"
        placeholder={t(placeholder)}
        {...formikProps}
        {...props}
      />

      <Typography
        variant="subtitle2"
        className={` ${
          isError || errorMessage ? "visible" : "invisible"
        } input-field-error-message`}
        sx={{ color: theme.palette.error.main }}
      >
        {isError ? t(get(errors, name, "")) : errorMessage}
      </Typography>
    </div>
  );
};

InputFieldText.propTypes = {
  formik: PropTypes.object,
  name: PropTypes.string,
  disabled: PropTypes.bool,
  errorMessage: PropTypes.string,
  t: PropTypes.func,
  placeholder: PropTypes.string,
};

export default withTranslation()(InputFieldText);
